import { Component, EventEmitter, forwardRef, HostListener, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { Calendar } from 'primeng/calendar';

@Component({
  selector: 'ui-datetime',
  templateUrl: './ui-datetime.component.html',
  styleUrls: ['./ui-datetime.component.css'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => UiDatetimeComponent),
    multi: true
  }]
})
export class UiDatetimeComponent implements OnChanges {
  @Output() onChange = new EventEmitter<any>();

  @Input() label?: string;
  @Input() inputId?: string;

  @Input() date?: Date;
  @Input() dateString?: string;

  @Input() placeholder: string = 'MM/DD/YYYY';
  @Input() touchUI: boolean = false;
  @Input() readOnly: boolean = false;
  @Input() datesDisabled?: Date[];
  @Input() daysDisabled?: string;
  @Input() view: string = "date";               //only valid values are "month" and "date"
  @Input() endOfMonth: boolean = false;
  @Input() defaultDate?: Date;
  @Input() minDate?: Date;
  @Input() maxDate?: Date;
  @Input() showOnFocus: boolean = true; //KNOWN ISSUE: this version of primeng throws an error when tabbing away if showOnFocus is false. Fix would be to update primeng.
  @Input() monthNavigator: boolean = false;
  @Input() yearNavigator: boolean = false;

  @ViewChild('cal') cal: Calendar;

  yearRange: string;

  value: Date;

  ngOnInit() {
    //Generate inputId if not provided - required to associate label with input for screen readers
    if (!this.inputId) {
      if (this.label) {
        //Hash function to generate id via label. Should be fairly collision-free.
        let Hash = s => { for (var i = 0, h = 9; i < s.length;) h = Math.imul(h ^ s.charCodeAt(i++), 9 ** 9); return h ^ h >>> 9 }
        this.inputId = Hash(this.label).toString();
      } else {
        //Naive approach to id generation. Collisions possible.
        this.inputId = Math.random() + "-" + Math.random();
      }
    }

    //Prefer this.date over this.dateString; 
    if (this.date) {
      if (typeof this.date == "string") {
        console.warn("String passed into ui-datetime component's [date] field. Use [dateString] instead.");
        this.value = new Date(this.date);
      }
      else this.value = this.date;
    }
    else if (this.dateString) this.value = new Date(this.dateString);

    //Parse max/min date to Date if passed in as strings
    if (this.minDate && typeof this.minDate == "string") this.minDate = new Date(Date.parse(this.minDate));
    if (this.maxDate && typeof this.maxDate == "string") this.maxDate = new Date(Date.parse(this.maxDate));

    //Set limits if yearNavigator dropdown enabled
    if (this.yearNavigator) {
      let minYear = this.minDate ? this.minDate.getFullYear() : new Date().getFullYear() - 144;
      let maxYear = this.maxDate ? this.maxDate.getFullYear() : new Date().getFullYear() + 10;
      this.yearRange = minYear + ":" + maxYear;
    }

    //Alter the placeHolder if in month mode
    if (this.view == 'month' && this.placeholder == 'MM/DD/YYYY') this.placeholder = 'MM/YYYY';
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.date) {
      if (!changes.date.currentValue) {
        this.value = null;
      } else {
        if (typeof this.date == "string") {
          console.warn("String passed into ui-datetime component's [date] field. Use [dateString] instead.");
          this.value = new Date(this.date);
        }
        else this.value = this.date;
      }
    }
    else if (changes.dateString) {
      this.value = (changes.dateString.currentValue ? new Date(this.dateString) : null);
    }
  }

  onValueChange(value: Date) {
    this.value = value;
    this.onChange.emit(value);
  }

  onToggle(value?) {
    //Check for the showOnFocus setting & whether event source is calendar's input element
    if (!this.showOnFocus && (value.srcElement == this.cal.inputfieldViewChild.nativeElement)) this.cal.toggle();
  }

  /* Makes adjustments to the selected date based on special conditions. Right now, that means
     skipping to the end of the month if flag set. */
  onDateSelect(event?) {
    if (this.view == 'month' && this.endOfMonth) {
      this.date = new Date(event.getFullYear(), event.getMonth() + 1, 0, 23, 59, 59);
    }
  }
}
